import { FilePdf } from "@phosphor-icons/react";
import { Reveal } from "./shared";

export default function Diagrams() {
  return (
    <section
      id="the-physics"
      data-testid="diagrams-section"
      className="py-20 md:py-28 bg-[#F1F5F9] border-b border-slate-300"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Reveal>
          <p className="font-mono text-xs font-semibold tracking-[0.25em] uppercase text-[#0284C7]">
            Without / With
          </p>
          <h2 className="mt-4 font-heading font-black uppercase tracking-tight text-3xl md:text-4xl text-slate-900 max-w-2xl leading-tight">
            Same window.{" "}
            <span className="text-[#0284C7]">Different physics.</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <Reveal>
            <img
              src="/assets/diagram-without-thermoglasspro.png"
              alt="Diagram: without ThermoGlassPro, visible light, infrared heat and UV rays pass straight through the window into the room"
              loading="lazy"
              data-testid="diagram-without-img"
              className="w-full h-auto block border border-slate-900 bg-white"
            />
          </Reveal>
          <Reveal delay={0.12}>
            <img
              src="/assets/diagram-with-thermoglasspro.png"
              alt="Diagram: with ThermoGlassPro coating, visible light passes through the window while infrared heat and UV are blocked outside"
              loading="lazy"
              data-testid="diagram-with-img"
              className="w-full h-auto block border border-slate-900 bg-white"
            />
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <figure
            data-testid="comparison-figure"
            className="mt-8 border border-slate-900 bg-white"
          >
            <div className="overflow-hidden">
              <img
                src="/assets/standard-vs-coated.webp"
                alt="Illustrative comparison: standard glass letting heat and UV/IR through at 38°C versus ThermoGlassPro coated glass rejecting them at 24°C"
                loading="lazy"
                className="w-full h-auto block"
              />
            </div>
          </figure>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap gap-3" data-testid="diagrams-pdf-links">
            <a
              data-testid="spec-sheet-download-btn"
              href="/assets/thermoglasspro-spec-sheet.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 bg-slate-900 text-white font-semibold px-6 py-3.5 hover:bg-[#0284C7] transition-colors duration-150"
            >
              <FilePdf size={20} weight="fill" />
              Spec sheet (PDF)
            </a>
            <a
              data-testid="tech-guide-download-btn"
              href="/assets/thermoglasspro-technical-guide.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 border border-slate-900 text-slate-900 font-semibold px-6 py-3.5 hover:bg-slate-900 hover:text-white transition-[background-color,color] duration-150"
            >
              <FilePdf size={20} weight="fill" />
              Technical guide: why windows heat (PDF)
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
